const IconX = () => {
  return (
    <path
      d="M16.3134 5.2207H18.6135L13.5884 10.964L19.5 18.7793H14.8706L11.2452 14.0394L7.097 18.7793H4.79551L10.1703 12.6362L4.5 5.2207H9.24551L12.5225 9.5532L16.3134 5.2207ZM15.5061 17.4026H16.7806L8.55368 6.52511H7.186L15.5061 17.4026Z"
      fill="currentColor"
      data-testid="icon-x"
    />
  );
};

export default IconX;
